import { createI18n } from 'vue-i18n'
import zhCN from './lang/zh_CN'
import enUS from './lang/en_US'


const savedLang = localStorage.getItem('lang') || navigator.language;

const i18n = createI18n({
    legacy: false,
    locale: savedLang,
    fallbackLocale: 'en',
    messages: {
        'zh': zhCN,
        'en': enUS,
        'zh-CN': zhCN,
        'en-US': enUS
    }
})

console.log(i18n.global.messages)
export default i18n
